import { jsx as _jsx } from "react/jsx-runtime";
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
export const ErrorLoadingAsync = ({
  retry
}) => /*#__PURE__*/_jsx(UIErrorMessage, {
  type: "badRequest",
  children: /*#__PURE__*/_jsx(UILink, {
    onClick: () => retry(),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "collaborationSidebar.panelLoad.error"
    })
  })
});